module.exports = __webpack_public_path__ + "img/9.6e4d4ff0.jpg";